import qs from 'qs'
import ApiService from './ApiService'

const resourceUrl = `${ApiService.prefix}rest/data/bulkUpdate`

export default {
  getBulkUpdateFields(componentId, fieldIds, bpdId, listBpdId) {
    const queryParams = {
      fieldId: fieldIds,
      bpdId,
      listBpdId,
    }
    return ApiService.get(`${resourceUrl}/definition/${componentId}`, {
      params: queryParams,
      paramsSerializer: (params) => qs.stringify(params, { indices: false }),
    })
  },
  postBulkUpdate(data) {
    return ApiService.post(`${resourceUrl}/save`, data)
  },
}
